export const url = "mapRequest.do";
export const attribution = "&copy; <a href=https://www.maanmittauslaitos.fi/avoindata-lisenssi-cc40>Maanmittauslaitos</a>";